module.exports = __webpack_public_path__ + "components/media-kit/static/icon-latin-america-01acaec840cb7b3d64cb1ae4d961bf31.svg";